import { useTranslation } from 'react-i18next';
import styles from './styles.module.css';

interface IDataUnavailableProps {
  /** Override the default "This data is unavailable right now…" copy. */
  message?: string;
  /** Extra class for container-specific sizing (e.g. a full-page takeover). */
  className?: string;
  /** A one-line note above content that still shows (one of several sources
   *  is down), instead of the panel that stands in for the whole surface. */
  compact?: boolean;
}

/**
 * Shared honest empty state shown when a provider-backed surface can't load its
 * data (provider not connected / session expired). Reconnecting is handled
 * globally by the TopBar reconnect button — this is intentionally just a
 * message, not an in-page reconnect control. One component so every page renders
 * the same neutral, centred treatment instead of each rolling its own.
 */
export function DataUnavailable({ message, className, compact = false }: IDataUnavailableProps) {
  const { t } = useTranslation();
  const classes = [styles.root, compact && styles.compact, className].filter(Boolean).join(' ');
  return (
    <div className={classes} role="status">
      <span>{message ?? t('common.dataUnavailable')}</span>
    </div>
  );
}
